var c = Object.getOwnPropertySymbols;
var R = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable;
var l = (n, e) => {
  var t = {};
  for (var s in n)
    R.call(n, s) && e.indexOf(s) < 0 && (t[s] = n[s]);
  if (n != null && c)
    for (var s of c(n))
      e.indexOf(s) < 0 && m.call(n, s) && (t[s] = n[s]);
  return t;
};
import { checkContentTypeHeader as h } from "./common.js";
import { resDataHandle as d, AESIV as p, AESKEY as q } from "../encry/index.js";
import o from "axios";
class a {
  constructor() {
    this.pendingRequests = /* @__PURE__ */ new Map(), this.removeRequestKey = this.removeRequestKey.bind(this), this.handleDuplicateRequests = this.handleDuplicateRequests.bind(this), this.handleRequestComplete = this.handleRequestComplete.bind(this), this.handleRequestError = this.handleRequestError.bind(this);
  }
  static removeSensitiveFields(e) {
    if (!e) return e;
    if (typeof e == "string") try {
      e = JSON.parse(e);
    } catch (s) {
      return console.warn("Failed to parse string to JSON:", e), e;
    }
    if (typeof e == "object" && e !== null) {
      const t = e, { sign: s, timestamp: u } = t;
      return l(t, ["sign", "timestamp"]);
    }
    return e;
  }
  static generateRequestKey(e) {
    const { url: t, method: s, headers: u } = e;
    let { params: i, data: r } = e;
    return h(u, "application/encrypted-json") && (i = i && d(i, q, p), r = r && d(r, q, p)), `${s || "get"}:${t}:${i ? JSON.stringify(a.removeSensitiveFields(i)) : ""}:${r ? JSON.stringify(a.removeSensitiveFields(r)) : ""}`;
  }
  removeRequestKey(e) {
    this.pendingRequests.has(e) && this.pendingRequests.delete(e);
  }
  handleDuplicateRequests(e) {
    const t = a.generateRequestKey(e);
    if (h(e.headers, "multipart/form-data")) return e;
    if (this.pendingRequests.has(t))
      throw o.CancelToken.source().cancel(`[Duplicate Request] Request canceled: ${t}`), new o.Cancel(`[Duplicate Request] Request canceled: ${t}`);
    const s = o.CancelToken.source();
    return e.cancelToken = s.token, this.pendingRequests.set(t, s), e;
  }
  handleRequestComplete(e) {
    const t = a.generateRequestKey(e.config);
    return this.removeRequestKey(t), e;
  }
  handleRequestError(e) {
    if (o.isCancel(e)) return new Promise(() => {
    });
    if (e.config) {
      const t = a.generateRequestKey(e.config);
      this.removeRequestKey(t);
    }
    return Promise.reject(e);
  }
}
export {
  a as default
};
